import { Feature, FeatureCollection } from 'geojson';

export const countryMapFeatureAdapter = (
  item: Offers.Components['CountryMap']['entries'][0],
): Feature => {
  return {
    geometry: {
      coordinates: [
        item.geoLocation?.longitude ?? 0,
        item.geoLocation?.latitude ?? 0,
      ],
      type: 'Point',
    },
    properties: {
      id: String(item.destinationId),
      markerLabel: item.destinationCard.headline,
      name: item.destinationCard.headline,
      type: 'Location',
    },
    type: 'Feature',
  };
};

export const countryMapFeatureCollectionAdapter = (
  items?: Offers.Components['CountryMap']['entries'],
): FeatureCollection => {
  if (!items) {
    return {
      features: [],
      type: 'FeatureCollection',
    };
  }

  return {
    features: items.map(item => countryMapFeatureAdapter(item)),
    type: 'FeatureCollection',
  };
};
